import React from "react";
import { ActionActivity } from "../ActionActivity";
import { CampaignActivityProps } from "../ActionActivityItem";
import { LinkIcon } from "../../../icons";

export const TransferMatchTransactionsActivity: React.FC<
    CampaignActivityProps
> = ({ animated }) => (
    <ActionActivity icon={<LinkIcon />} animated={animated}>
        Transactions matched
    </ActionActivity>
);
